<h1 mat-dialog-title>Adauga un o proprietate noua </h1>

<dynamic-form [fields]="regConfig" (submit)="submit($event)"> </dynamic-form>

